import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA037_Request,
  IAPI_STA037_Response,
  IAPI_STA038_Request,
  IAPI_STA038_Response,
  IAPI_STA008_Request,
  IAPI_STA008_Response,
} from "../../../type/apiType";

// 書類の添付参照
const httpAPI_STA037 = async (
  param: IAPI_STA037_Request
): Promise<IAPI_STA037_Response> => {
  let res = await http.post(ApiUrl.API_STA037, {
    ...param,
  });

  return res.data;
};

// 書類の添付更新
const httpAPI_STA038 = async (
  param: IAPI_STA038_Request
): Promise<IAPI_STA038_Response> => {
  let res = await http.post(ApiUrl.API_STA038, {
    ...param,
  });

  return res.data;
};

// 退職者詳細情報更新
const httpAPI_STA008 = async (
  param: IAPI_STA008_Request
): Promise<IAPI_STA008_Response> => {
  let res = await http.post(ApiUrl.API_STA008, {
    ...param,
  });
  return res.data;
};

export { httpAPI_STA037, httpAPI_STA038, httpAPI_STA008 };
